function createQueue() {
  const queue = [];
  return {
    enqueue: (item) => queue.push(item),
    dequeue: () => queue.shift(),
    isEmpty: () => queue.length === 0,
    size: () => queue.length,
    pick: (item) => queue.find((i) => i === item),
    omit: (item) => {
      const index = queue.indexOf(item);
      if (index !== -1) {
        queue.splice(index, 1);
      }
    },
    forEach: (...params) => queue.forEach(...params),
    flush: (callbackfn) => {
      while (queue.length > 0) {
        callbackfn(queue.shift());
      }
    }
  };
}

export { createQueue };
//# sourceMappingURL=simpleQueue.mjs.map
